import cn from 'classnames';
import { Button } from '../button';
import { Icon } from '../icon';
import { Image } from '../image';

type P = {
  alt: string;
  borderBottom?: boolean;
  onRequestEdit?: () => void;
  size?: 'large' | 'small';
  src: string;
};

/**
 * @deprecated
 * Use HeaderAsset instead
 */
const HeaderImage = ({ alt, borderBottom = true, onRequestEdit, size = 'large', src }: P) => (
  <div className="header-image">
    <Image
      alt={alt}
      className="header-image__cover__content"
      rootClassName={cn('header-image__cover', {
        'header-image__cover--border-bottom': borderBottom,
        'header-image__cover--small': size === 'small',
      })}
      src={src}
    />
    {onRequestEdit ? (
      <Button className="header-image__edit" icon={<Icon icon="pencil-line" />} onClick={onRequestEdit} />
    ) : null}
  </div>
);

export default HeaderImage;
